export const checkValidDate = (date: Date | null) => {
  return date instanceof Date && !isNaN(date as never);
};
